import { css } from 'styled-components'

export const mixinInputForm = css`
  border: 1px solid ${props => props.theme.members.colors.silver._70};
  padding: 1rem;
  line-height: 1;
  font-size: .875rem;
  width: 100%;
`

export const mixinInputFormClasses = (hasError = false, size = 'default') => {
  const conditionalColorClass = hasError ? 'border-member-red-100' : 'border-member-gray-40 focus:border-member-green-100 focus:bg-member-gray-10'
  const sizeClass = size === 'small' ? 'text-S! px-S py-XS' : 'text-M! p-S'

  return `
    border-1 ${conditionalColorClass} rounded ${sizeClass} w-full placeholder-member-gray-40 text-member-gray-100 bg-member-gray-0
    focus:outline-none disabled:bg-member-gray-30 disabled:cursor-not-allowed
  `
}

export const mixinErrorMessageClasses = 'flex items-center mt-XS text-S font-normal text-member-red-100 gap-2XS'
